import { useEffect, useRef } from 'react';

const IdentifyToggleWidget = ({ view, popupEnabled, setPopupEnabled }) => {
  const buttonRef = useRef(null);

  // Create the button once
  useEffect(() => {
    if (!view || buttonRef.current) return;

    const button = document.createElement('button');
    button.className = 'esri-widget';
    button.style.padding = '7px';
    button.style.marginTop = '8px';
    button.style.verticalAlign = 'middle';
    button.style.color = '#000';
    button.style.border = 'none';
    button.style.borderRadius = '4px';
    button.style.cursor = 'pointer';
    button.innerHTML = '🔍';

    button.onclick = () => {
      setPopupEnabled(prev => !prev);
    };

    buttonRef.current = button;
    view.ui.add(button, { position: 'top-left', index: 9 });

    return () => {
      view.ui.remove(button);
      buttonRef.current = null;
    };
  }, [view, setPopupEnabled]);

  // Update button style and title when popupEnabled changes
  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.style.backgroundColor = popupEnabled ? '#ffffff92' : '#FFFFFF';
      buttonRef.current.title = popupEnabled ? 'Disable Identify' : 'Enable Identify';
    }
  }, [popupEnabled]);

  return null;
};

export default IdentifyToggleWidget;
